import { Divider, Tooltip } from 'antd'
import Button from 'components/Button/index'
import CloseFilter from 'components/icons/CloseFilter'
import SearchInput from 'components/SearchInputReport'
import { Wrapper } from 'components/TableStyles/TableContentStyles/TableContentStyles'
import ReportSearchFilter from 'components/UIComponents/ReportSearchFilter'
import {
  Container,
  Content,
  FilterTextNew,
  Footer,
  MarginLeft,
} from 'components/UIComponents/ReportSearchFilter/Style/style'
import { arrayIntoString } from 'modules/Reports/Components/CommonFunction/CommonFunctionIndex'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setStudentSkillWiseDetails } from '../../../actions'
import CityFilter from '../../Filter/SingleFilter'
import DegreeAndDepartmentFilter from '../../Filter/TreeFilter'
const Top10InstituteFilter = ({
  searchValue,
  setSearchValue,
  pageNum,
  tableData,
  degreeList,
  setKeyDegree,
  courseValue,
  collegeValue,
  specialisationValue,
  setFilterData,
  nameValue,
  tierValue,
  setTierValue,
  setKeyTier,
  keyTier,
  universityValue,
  setUniversityValue,
  setKeyUniversity,
  keyUniversity,
  cityValue,
  setCityValue,
  setSkillValue,
  skillValue,
  TierUrl,
  SpecialisationUrl,
  tierData,
  specialisationData,
  tierLoader,
  universityLoader,
  cityLoader,
  setUniversityLoader,
  setTierLoader,
  setCityLoader,
  CityUrl,
  cityData,
  degreeListData,
  setDegreeList,
  setSearchDegree,
  degreeLoader,
  searchQuery,
  setSearchQuery,
  tooltip,
  skillData,
  setSkillLoader,
  SkillUrl,
  skillLoader,
  page,
  count,
  loadMoreData,
  loadingDep,
  DegreeUrl,
  flag,
  setLoadingDep,
  searchDegree,
  setDegreeLoader,
}) => {
  const dispatch = useDispatch()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [clearFlag, setClearFlag] = useState(false)
  const [search, setSearch] = useState('')
  const [open, setOpen] = useState(true)
  const [skill, setSkill] = useState('')
  const [searchCity, setSearchCity] = useState('')
  const [filterCancel, setFilterCancel] = useState(false)
  const submitFilter = () => {
    setIsMenuOpen(false)
    const modifiedNames = universityValue.map(name => name?.replace(',', '$'))
    let college = arrayIntoString(collegeValue)
    let course = arrayIntoString(courseValue)
    let specialisation = arrayIntoString(specialisationValue)
    let degree = arrayIntoString(degreeList)
    let corporate = arrayIntoString(nameValue)
    let skill = arrayIntoString(skillValue)
    let tier = arrayIntoString(tierValue)
    let university = arrayIntoString(modifiedNames)
    let city = arrayIntoString(cityValue)
    setIsMenuOpen(false)
    setFilterData({
      college: college,
      course: course,
      specialisation: specialisation,
      degree: degree,
      corporate: corporate,
      skill: skill,
      tier: tier,
      university: university,
      city: city,
    })
  }

  const onCancelFilter = open => {
    setClearFlag(true)
    setIsMenuOpen(!isMenuOpen)
    setCityValue([])
    setTierValue([])
    setUniversityValue([])
    dispatch(setStudentSkillWiseDetails([]))
    setDegreeList([])
    setKeyTier('')
    setSearch('')
    setKeyUniversity('')
    setSearchValue('')
    setSearchCity('')
    setSearchQuery('')
    setFilterCancel(true)
    setSkillValue([])
    DegreeUrl(
      (flag = 'SSW'),
      setLoadingDep,
      (searchDegree = ''),
      0,
      setDegreeLoader
    )
  }
  const onDegreeFilterChange = data => {
    setDegreeList(data)
  }

  useEffect(() => {
    dispatch(setStudentSkillWiseDetails([]))
  }, [])
  return (
    <Wrapper>
      <ReportSearchFilter
        setOpen={setOpen}
        open={open}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        isReport={true}
        totalCount={tableData?.count}
        currentCount={10 * (pageNum - 1) + tableData?.result?.length}
      />
      <Divider style={{ margin: '0' }} />
      <Content isOpen={open}>
        <div style={{ width: '100%', display: 'flex', height: '18rem' }}>
          <Wrapper style={{ marginLeft: '1rem' }}>
            <FilterTextNew>{'Degree & Department'}</FilterTextNew>
            <SearchInput
              width={'90%'}
              placeholder="Search by keyword"
              bordered={true}
              searchValue={searchQuery}
              setSearchValue={value => {
                setSearchQuery(value)
                setKeyDegree(value)
              }}
              clearFlag={clearFlag}
              setClearFlag={setClearFlag}
            />
            <Container>
              <DegreeAndDepartmentFilter
                degreeList={degreeListData}
                setDegreeList={onDegreeFilterChange}
                searchQuery={searchQuery}
                degree={degreeList}
                setSearchDegree={setSearchDegree}
                loading={degreeLoader}
                filterCancel={filterCancel}
                setFilterCancel={setFilterCancel}
                degreeLoader={loadingDep}
                page={page}
                count={count}
                loadMoreData={loadMoreData}
              />
            </Container>
          </Wrapper>
          <Divider
            type="vertical"
            style={{
              height: '100%',
              width: '2px',
              borderTop: '18rem solid #e8e8e8',
            }}
          />

          <Wrapper style={{ marginLeft: '1rem' }}>
            <FilterTextNew>{'Skills'}</FilterTextNew>
            <SearchInput
              width={'90%'}
              placeholder="Search by keyword"
              bordered={true}
              searchValue={skill}
              setSearchValue={value => {
                setSkill(value)
              }}
              clearFlag={clearFlag}
              setClearFlag={setClearFlag}
            />
            <Container>
              <CityFilter
                value={skillValue}
                setValue={setSkillValue}
                search={skill}
                setSearch={setSkill}
                cityData={skillData}
                cityDetails={SkillUrl}
                setLoading={setSkillLoader}
                loading={skillLoader}
                valueParam={'name'}
                labelParam={'name'}
              />
            </Container>
          </Wrapper>
          <Divider
            type="vertical"
            style={{
              height: '100%',
              width: '2px',
              borderTop: '18rem solid #e8e8e8',
            }}
          />
          <Wrapper>
            <FilterTextNew>{'University'}</FilterTextNew>
            <SearchInput
              width={'90%'}
              placeholder="Search by keyword"
              bordered={true}
              searchValue={keyUniversity}
              setSearchValue={value => {
                setKeyUniversity(value)
              }}
              clearFlag={clearFlag}
              setClearFlag={setClearFlag}
            />
            <Container>
              <CityFilter
                search={keyUniversity}
                setSearch={setKeyUniversity}
                value={universityValue}
                setValue={setUniversityValue}
                cityData={specialisationData}
                cityDetails={SpecialisationUrl}
                setLoading={setUniversityLoader}
                loading={universityLoader}
                valueParam={'university'}
                labelParam={'university'}
                flag={'SSW'}
              />
            </Container>
          </Wrapper>

          <Divider
            type="vertical"
            style={{
              height: '100%',
              width: '2px',
              borderTop: '18rem solid #e8e8e8',
            }}
          />
          <Wrapper>
            <FilterTextNew>{'Tier'}</FilterTextNew>
            <SearchInput
              width={'90%'}
              placeholder="Search by keyword"
              bordered={true}
              searchValue={keyTier}
              setSearchValue={value => {
                setKeyTier(value)
              }}
              clearFlag={clearFlag}
              setClearFlag={setClearFlag}
            />
            <Container>
              <CityFilter
                value={tierValue}
                setValue={setTierValue}
                search={keyTier}
                setSearch={setKeyTier}
                cityData={tierData}
                cityDetails={TierUrl}
                setLoading={setTierLoader}
                loading={tierLoader}
                valueParam={'tier'}
                labelParam={'tier'}
                flag={'SSW'}
              />
            </Container>
          </Wrapper>
          <Divider
            type="vertical"
            style={{
              height: '100%',
              width: '2px',
              borderTop: '18rem solid #e8e8e8',
            }}
          />
          <Wrapper>
            <FilterTextNew>{'Location'}</FilterTextNew>
            <SearchInput
              width={'90%'}
              placeholder="Search by keyword"
              bordered={true}
              searchValue={searchCity}
              setSearchValue={value => {
                setSearchCity(value)
              }}
              clearFlag={clearFlag}
              setClearFlag={setClearFlag}
            />
            <Container>
              <CityFilter
                search={searchCity}
                setSearch={setSearchCity}
                value={cityValue}
                setValue={setCityValue}
                cityData={cityData}
                cityDetails={CityUrl}
                setLoading={setCityLoader}
                loading={cityLoader}
                valueParam={'corr_city'}
                labelParam={'corr_city'}
                flag={'SSW'}
              />
            </Container>
          </Wrapper>

          <Divider
            type="vertical"
            style={{
              height: '100%',
              width: '2px',
              borderTop: '18rem solid #e8e8e8',
            }}
          />
        </div>
      </Content>
      <Divider style={{ margin: '0' }} />
      <Footer style={{ display: open ? '' : 'none' }}>
        <div
          style={{ marginRight: '180px' }}
          role="button"
          tabIndex="0"
          onClick={() => {
            setOpen(false)
          }}
          onKeyDown={() => {}}
        >
          <CloseFilter style={{ marginBottom: '-20px', cursor: 'pointer' }} />
        </div>
        <div style={{ marginRight: '30px' }}>
          <Button.Secondary
            height="35px"
            htmlType="Clear"
            text={'Clear Filter'}
            width={'144px'}
            onClick={() => onCancelFilter()}
          />
        </div>
        <div style={{ marginRight: '10px' }}>
          <MarginLeft>
            <Tooltip
              placement="topLeft"
              title={
                !tooltip
                  ? 'Kindly Select Filter Option Before Submitting the Data'
                  : ''
              }
            >
              <Button.Primary
                disabled={!tooltip}
                height="35px"
                htmlType="Save Filter"
                text={'Apply'}
                width={'144px'}
                onClick={() => submitFilter()}
              />
            </Tooltip>
          </MarginLeft>
        </div>
      </Footer>
      <Divider style={{ margin: '0' }} />
    </Wrapper>
  )
}

export default Top10InstituteFilter
